// extracted by mini-css-extract-plugin
export default {"root":"Page_root__okZ1E","alertContainer":"Page_alertContainer__ix2qt","LoginLink":"Page_LoginLink__hYxL2","menuIcon":"Page_menuIcon__eNKEi"};